import React from 'react';
import './Visuals.scss';

const TopContent: React.FC<{ title: string, subTitle?: string | undefined }> = props => {
    return (
        <div className="topContentContainer">
            <div className="backCenteredContainer">
                <div>
                    <h1 className="title">{props.title}</h1>
                    {
                        props.subTitle && <div className="subTitle">{props.subTitle}</div>
                    }
                </div>
            </div>
        </div>
    );
};

export default TopContent;
